import _objectSpread from"/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";import _objectWithoutProperties from"/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";var _excluded=["onClose","open","title","profile"];import React from'react';// Icons
// import AddAlertIcon from '@mui/icons-material/AddAlert';
// import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
// MUI
// import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
// import { styled } from '@mui/material/styles';
// Components
// import BasicForm from './Basic';
// import CardButton from 'components/v2/FormElements/CardButton';
// import DialogButtons from 'components/v2/FormElements/DialogV2/Buttons';
import NotifyGrid from'components/v2/Reportables/Notify';// import TicketForm from './Ticket';
import TswDialog from'components/v2/FormElements/DialogV2';import{withFeatureState}from'../state';// const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
//   display: 'grid',
//   gridAutoColumns: '1fr',
//   gap: '0',
// }));
import{jsx as _jsx}from"react/jsx-runtime";export var Dialog=function Dialog(_ref){var onClose=_ref.onClose,open=_ref.open,title=_ref.title,profile=_ref.profile,rest=_objectWithoutProperties(_ref,_excluded);// const [type, setType] = React.useState('reportable');
// const isEmployee = profile?.role === 'employee';
// const handleChange = (event, type) => {
//   if (type !== null) {
//     setType(type);
//   }
// };
// const handleClick = () => {
//   console.log('handleClick'); // eslint-disable-line
//   onClose();
// };
// const modalActions = (
//   <DialogButtons
//     onCancel={onClose}
//     onClick={handleClick}
//     // disabled={disabled}
//     clickText={'Next'}
//   />
// );
var modalProps={onClose:onClose,title:title,open:open,maxWidth:'xl',fullWidth:true// actions: type === 'ticket' && modalActions,
};return/*#__PURE__*/_jsx(TswDialog,_objectSpread(_objectSpread({},modalProps),{},{children:/*#__PURE__*/_jsx(NotifyGrid,{onClose:onClose})}));};export default withFeatureState(Dialog);